import {
  FROM_ORIGIN,
  LAST_SEVEN_DAYS,
  LAST_THIRTY_DAYS,
  THIS_MONTH,
} from '@/constants';

export default {
  'date-picker.see': 'Aplicar',
  [`date-picker.${FROM_ORIGIN}`]: 'Desde siempre',
  [`date-picker.${LAST_SEVEN_DAYS}`]: 'Últimos 7 días',
  [`date-picker.${LAST_THIRTY_DAYS}`]: 'Últimos 30 días',
  [`date-picker.${THIS_MONTH}`]: 'Este mes',
};
